import { useEffect, useState } from "react";
import { api, apiError } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { toast, Toaster } from "sonner";

export default function Users() {
  const [rows, setRows] = useState([]);
  const load = () => api.get("/masters/users").then((r) => setRows(r.data));
  useEffect(() => { load(); }, []);

  const update = async (uid, patch) => {
    try { await api.patch(`/masters/users/${uid}`, patch); toast.success("Updated"); load(); }
    catch (e) { toast.error(apiError(e)); }
  };

  return (
    <div className="space-y-4" data-testid="users-root">
      <Toaster position="top-center" />
      <h1 className="text-2xl sm:text-3xl font-bold tracking-tight text-slate-900">Users</h1>
      <Card className="p-3 border-2 border-slate-300 rounded-sm">
        <table className="dense-table w-full text-sm">
          <thead><tr><th>Name</th><th>Email</th><th>Role</th><th>Active</th></tr></thead>
          <tbody>
            {rows.map((u) => (
              <tr key={u.user_id}>
                <td>{u.name}</td>
                <td className="font-mono">{u.email}</td>
                <td>
                  <select value={u.role} onChange={(e) => update(u.user_id, { role: e.target.value })} className="border border-slate-300 rounded-sm p-1" data-testid={`role-select-${u.user_id}`}>
                    {[
                      { v: "owner", l: "Owner" },
                      { v: "admin", l: "Admin" },
                      { v: "manager", l: "Manager" },
                      { v: "assistant_manager", l: "Supervisor" },
                      { v: "cashier", l: "Cashier" },
                      { v: "filler", l: "Filler" },
                    ].map((r) => <option key={r.v} value={r.v}>{r.l}</option>)}
                  </select>
                </td>
                <td>
                  <Button size="sm" variant="outline" onClick={() => update(u.user_id, { active: !u.active })} className="text-xs h-7 border-slate-300">
                    {u.active ? "Deactivate" : "Activate"}
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
